import React from 'react';
import { Condition } from '../../../../../../types/rest/dslTypes';
import _ from 'lodash';
import { DEFAULT_POPPER_CONFIG } from '../../../../../../constants/ui-constants';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import PopoverContent from '../../../../../../components/overlays/Popover/PopoverContent';

interface ConditionsCellProps {
  conditions: Condition[];
}

const ConditionsCell = (props: ConditionsCellProps) => {
  const { conditions } = props;
  if (_.size(conditions) === 0) {
    return <span>-</span>;
  }

  const getMatcherString = (condition: Condition) => {
    if (_.isNil(condition)) {
      return;
    }
    return 'if ' + condition.matcher.key + ' ' + condition.matcher.matcherName + ' ' + condition.matcher.matchingValue;
  };

  const getMatcherCell = (condition: Condition, isMultipleCondition: boolean) => {
    const text = getMatcherString(condition);
    return (
      <span
        style={{ maxWidth: isMultipleCondition ? '84%' : '100%' }}
        className={'text-truncate d-inline-block align-middle'}
        title={text}
      >
        {text}
      </span>
    );
  };
  const getPopOverContent = (conditions: Condition[]) => {
    return (
      <Popover style={{ minWidth: 300 }} id={_.uniqueId('condition-popover-')}>
        <PopoverContent>
          <PopoverContent.Header>Conditions</PopoverContent.Header>
          <PopoverContent.Body>
            {_.map(conditions, (item: Condition, index) => {
              if (index == 0) {
                return;
              }
              return <p className={'p-1 mb-3'}>{getMatcherString(item)}</p>;
            })}
          </PopoverContent.Body>
        </PopoverContent>
      </Popover>
    );
  };
  const isMultiple = conditions.length > 1;
  const extraConditions = conditions.length - 1;
  return (
    <div style={{ width: '100%' }}>
      {getMatcherCell(conditions[0], isMultiple)}
      {isMultiple && (
        <OverlayTrigger
          trigger={'click'}
          placement="bottom"
          popperConfig={DEFAULT_POPPER_CONFIG}
          overlay={getPopOverContent(conditions)}
        >
          <span className={'ml-3 font-weight-semi-bold text-info align-middle hand-cursor'}>(+{extraConditions})</span>
        </OverlayTrigger>
      )}
    </div>
  );
};

export default ConditionsCell;
